import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { Input } from '../../../../components/Input'
import { ReactComponent as LoginIcon } from '../../../../assets/img/logo-login.svg'
import { ReactComponent as PasswordIcon } from '../../../../assets/img/logo-password.svg'
import TMLogo from '../../../../assets/img/logo_accent.png'
import './AuthForm.sass'
import { Button } from '../../../../components/Button'
import { loginCall } from './AuthForm-api'
import { ResponseSuccessType } from './AuthForm-types'
import qs from 'query-string'

export const AuthForm = () => {
  const params = useSearchParams();
  // As base64: https://app.targetmap.net/main
  const appName = params[0].get('from') ?? 'aHR0cHM6Ly9hcHAudGFyZ2V0bWFwLm5ldC9tYWlu';

  const [login, setLogin] = React.useState<string>('')
  const [password, setPassword] = React.useState<string>('')
  const [loading, setLoading] = React.useState<boolean>(false)
  const [error, setError] = React.useState<string>('')

  const handleLoginChange = (e: React.FormEvent<HTMLInputElement>) => {
    setLogin(e.currentTarget.value)
  }
  const handlePasswordChange = (e: React.FormEvent<HTMLInputElement>) => {
    setPassword(e.currentTarget.value)
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    if (login && password) {
      setLoading(true)
      try {
        const result: ResponseSuccessType = await loginCall({ login, password })
        const decodedAppUrl = atob(appName)
        const parsedUrl = qs.parseUrl(decodedAppUrl)
        parsedUrl.query.access = result.access_token
        parsedUrl.query.refresh = result.refresh_token
        const urlForRedirect = qs.stringifyUrl(parsedUrl)

        window.location.replace(urlForRedirect)
        setPassword('')
        setLogin('')
      } catch (error: any) {
        setError(error)
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <form className='auth-form' onSubmit={handleSubmit}>
	  <div>
	    <div className='auth-form__logo-wrapper'>
		  <img src={TMLogo} alt='Логотип' className='auth-form__logo'/>
		</div>
		<div className='auth-form__title'>
          Войдите, чтобы воспользоваться системой
        </div>
	  </div>
      <Input
        type='text'
        lightMode
        className='auth-form__control'
        placeholder='Логин'
        Icon={LoginIcon}
        value={login}
        onChange={handleLoginChange}
      />
      <Input
        type='password'
        lightMode
        className='auth-form__control'
        placeholder='Пароль'
        Icon={PasswordIcon}
        value={password}
        onChange={handlePasswordChange}
      />
      <Button
        htmlType='submit'
        className='auth-form__btn'
        disabled={!login || !password}
        loading={loading}
      >
        Запустить
      </Button>
      <div className={"auth-form__registartion-info"}>
              Регистрация доступна через Telegram <a href={"https://t.me/targetmapregistrationbot"}>@targetmapregistrationbot</a>
      </div>
      {error && <span className='auth-form__error'>{error}</span>}
    </form>
  )
}
